'use strict';

/**
 * @name pay
 */

exports.payment = require('./payment.js');
exports.getFingerprint = require('./get-fingerprint.js');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/pay/index.js
// module id = 607
// module chunks = 0